import type { ContextFileTypeTag } from '../projects/types';

// Keep in sync with backend allowedExtensions whitelist. Narrower than the
// org/context-file dialogs, which still list .reqifz and .xlsx.
export const ALLOWED_EXTENSIONS = new Set([
  '.a2l',
  '.arxml',
  '.c',
  '.capl',
  '.cpp',
  '.csv',
  '.dbc',
  '.docx',
  '.fibex',
  '.h',
  '.html',
  '.json',
  '.ldf',
  '.m',
  '.md',
  '.odx',
  '.pdf',
  '.py',
  '.reqif',
  '.rst',
  '.txt',
  '.vbs',
  '.xml',
  '.yaml',
]);

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

const EXTENSION_TO_TYPE_TAG: Record<string, ContextFileTypeTag> = {
  '.reqif': 'SYS2_REQUIREMENT',
  '.capl': 'SYS5_TEST_SCRIPT',
  '.vbs': 'SYS5_TEST_SCRIPT',
  '.arxml': 'API_DESCRIPTOR',
  '.fibex': 'API_DESCRIPTOR',
  '.ldf': 'API_DESCRIPTOR',
  '.dbc': 'API_DESCRIPTOR',
  '.odx': 'API_DESCRIPTOR',
  '.a2l': 'API_DESCRIPTOR',
};

export function fileExtension(name: string): string {
  return `.${name.split('.').pop()?.toLowerCase() ?? ''}`;
}

/** The backend requires a type tag; the dialog has no picker, so infer it. */
export function inferTypeTag(name: string): ContextFileTypeTag {
  return EXTENSION_TO_TYPE_TAG[fileExtension(name)] ?? 'GENERAL';
}

export type FileRuleViolation = 'tooLarge' | 'invalidType';

export function checkFile(file: File): FileRuleViolation | undefined {
  if (file.size > MAX_FILE_SIZE) return 'tooLarge';
  if (!ALLOWED_EXTENSIONS.has(fileExtension(file.name))) return 'invalidType';
  return undefined;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
